import React from "react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <div className={styles.footer}>
      <span className={styles.copyright}>© Flavia Nistor 2026</span>
    </div>
  );
};

export default Footer;
